import { render, staticRenderFns } from "./GramChart.vue?vue&type=template&id=44cce22e&scoped=true"
import script from "./GramChart.vue?vue&type=script&lang=ts"
export * from "./GramChart.vue?vue&type=script&lang=ts"
import style0 from "./GramChart.vue?vue&type=style&index=0&id=44cce22e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cce22e",
  null
  
)

export default component.exports